module.exports = __webpack_public_path__ + "img/List.598cbdfc.svg";